<template>
  <sc-alert type="info">
    <span v-if="taxReturnStatus === 'sending'"
      ><b>Note:</b> This page is <b>Readonly</b> because the tax return is being
      delivered.</span
    >
    <span
      v-else-if="taxReturnStatus === 'sent' || taxReturnStatus === 'completed'"
      ><b>Note:</b> This page is <b>READONLY</b> because the tax return has been
      delivered.</span
    >
    <span v-else
      ><b>Note:</b> This page is <b>READONLY</b> because the tax return is under
      processing.</span
    >
    <sc-button-group slot="button-group">
      <sc-button
        type="ghost"
        icon-left="arrow-right"
        @click="$emit('next')"
        :is-loading="loading"
        :is-disabled="disabled"
      >
        Next
      </sc-button>
    </sc-button-group>
  </sc-alert>
</template>

<script>
export default {
  props: {
    taxReturnStatus: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
